<template>
    <HelpPage></HelpPage>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const HelpPage = defineAsyncComponent(() =>
    import(
        "../../components/Logistics/HelpPage/HelpPage.vue"
        )
);

export default {
    name: "Logistics_Help", 
    components: { HelpPage, AuthLayout },
};
</script>
